import { Button, styled } from '@mui/material';

export const DoneButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#4caf50',
    color: 'white',
    fontSize: '0.75rem',
    padding: '4px 12px',
    '&:hover': {
        backgroundColor: '#45a049'
    }
}));